module.exports = __webpack_public_path__ + "img/mini-logo.e73c9b40.jpg";